import React, { useState, useEffect, useCallback, useRef } from "react";
import {
    Layout,
    Button,
    Row,
    Form,
    Input,
    Col,
    Select,
    Collapse,
    Modal,
    notification,
    Tag,
    Typography,
} from "antd";
import { useNavigate } from "react-router-dom";
import TopHeader from "../../common/TopHeader/TopHeader";
import Sidebar from "../../common/Sidebar/Sidebar";
import UserApi from "../../common/Apis/UserApi";
import FooterDashboard from "../../common/FooterDashboard/FooterDashboard";
import Pagination from "../../common/Pagination/Pagination"; 
import "../../common/Pagination/Pagination.css"; 

import {
    MinusCircleTwoTone,
    PlusCircleTwoTone,
} from "@ant-design/icons";
import QuestionnairesApi from "../../common/Apis/QuestionnairesApi";

const { confirm } = Modal;
const { Text } = Typography;

const OnboardedUsers = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const id = urlParams.get("id");
    const navigate = useNavigate();
    const { Content } = Layout;
    const { Panel } = Collapse;

    const [TenantsUsers, setTenantsUsers] = useState([]);
    const [PaginatePage, setPaginatePage] = useState(0);
    const [PaginatetotalPages, settotalPages] = useState(null);
    const [PaginateLimit, setPaginateLimit] = useState(10);
    const [totalElements, setTotalElements] = useState(0);
    const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));

    const [formPaginate] = Form.useForm();

    const [currentPage, setCurrentPage] = useState(1);
    const [isLoading, setIsLoading] = useState(false);

    const [filterUser, setFilterUser] = useState([
        { title: "", answerType: "", name: "" },
    ]);

    // -------------------------
    // Assign Login Code Modal
    // -------------------------
    const [isAssignModalVisible, setIsAssignModalVisible] = useState(false);
    const [selectedUser, setSelectedUser] = useState(null);
    const [loginCode, setLoginCode] = useState("");
    const [loginCodeError, setLoginCodeError] = useState("");

    const validateLoginCode = (value) => {
        if (!value) return "Login code is required";
        const regex = /^[a-zA-Z0-9]+$/;
        if (!regex.test(value)) return "Only letters and numbers allowed (no spaces/special chars)";
        return "";
    };

    const handleLoginCodeChange = (e) => {
        const value = e.target.value;
        setLoginCode(value);
        setLoginCodeError(validateLoginCode(value));
    };

    const handleAssignLoginCode = () => {
        const error = validateLoginCode(loginCode);
        if (error) {
            setLoginCodeError(error);
            return;
        }

        const data = {
            "id": selectedUser?.id,
            "laptopMac": "12345",
            "userId": loginCode,
            "tenantDTO":{
                "id": selectedUser.tenantDTO.id
            }
        };

        UserApi.AssignLoginCode(selectedUser?.id, data)
            .then(() => {
                notification.success({
                    message: "Success",
                    description: "Login code assigned successfully",
                });
                setIsAssignModalVisible(false);
                setLoginCode("");
                getOnboarderedUsers();
            })
            .catch((err) => {
                notification.error({
                    message: "Error",
                    description: err.apiError?.message || "Something went wrong",
                });
            });
    };

    // -------------------------
    // Fetch users
    // -------------------------
    const getOnboarderedUsers = useCallback(() => {
        UserApi.GetOnboarderdUsers(PaginatePage, PaginateLimit)
            .then((response) => {
                settotalPages(response.totalPages);
                setTenantsUsers(response.payload);
                setTotalElements(response.totalElements);

            })
            .catch((err) => {
                console.log(err);
            });
    }, [PaginatePage, PaginateLimit]);

    const PageLoading = useCallback(() => {
        setIsLoading(true);
        setTimeout(() => setIsLoading(false), 800);
    }, []);

    useEffect(() => {
        getOnboarderedUsers();
        PageLoading();
    }, [getOnboarderedUsers, PageLoading]);

    const handlePageChange = (page) => {
        setCurrentPage(page);
        let pageNew = page - 1;
        UserApi.tenantUsers(id, pageNew, PaginateLimit)
            .then((response) => {
                setPaginatePage(pageNew);
                settotalPages(response.totalPages);
                setTenantsUsers(response.payload);
                setTotalElements(response.totalElements);

            })
            .catch(console.log);
    };

    const handlesetPaginateLimit = (value) => {
        setPaginateLimit(value);
        setCurrentPage(1);
        UserApi.tenantUsers(id, 0, value)
            .then((response) => {
                settotalPages(response.totalPages);
                setTenantsUsers(response.payload);
                setTotalElements(response.totalElements);

            })
            .catch(console.log);
    };

    // -------------------------
    // Filter logic
    // -------------------------
    const handleChangeTitle = (index, value) => {
        const newFilter = [...filterUser];
        newFilter[index].title = value;
        setFilterUser(newFilter);
    };
    const handleChangeAnswertype = (index, value) => {
        const newFilter = [...filterUser];
        newFilter[index].answerType = value;
        setFilterUser(newFilter);
    };
    const handleChangename = (index, value) => {
        const newFilter = [...filterUser];
        newFilter[index].name = value;
        setFilterUser(newFilter);
    };
    const handleAddfilterUser = () => {
        setFilterUser([...filterUser, { title: "", answerType: "", name: "" }]);
    };
    const handleRemovefilterUser = (index) => {
        const newFilter = [...filterUser];
        newFilter.splice(index, 1);
        setFilterUser(newFilter);
        if (index === 0) getOnboarderedUsers();
    };
    const handleClear = () => {
        setFilterUser([{ title: "", answerType: "", name: "" }]);
        getOnboarderedUsers();
        PageLoading();
    };
    const handleSubmit = () => {
        let singleLineString = filterUser
            .map((obj) =>
                obj.answerType === "%"
                    ? `${obj.title}=${obj.answerType}${obj.name}${obj.answerType}`
                    : `${obj.title}${obj.answerType}${obj.name}`
            )
            .join("&");
        let filderData = window.btoa("componentCode=USER&subTenant.id=" + decodedToken?.subTenantId + "&" + singleLineString
);
        QuestionnairesApi.FilterQuestionsetNext(filderData, 0, PaginateLimit)
            .then((response) => {
                PageLoading();
                setCurrentPage(1);
                settotalPages(response.totalPages);
                setTenantsUsers(response.payload);
                setTotalElements(response.totalElements);

            })
            .catch(console.log);
    };

    // -------------------------
    // Delete and Resend
    // -------------------------
    const handleDeleteUser = (userId) => {
        UserApi.DeleteUsers(userId)
            .then(() => {
                notification.success({ message: "Deleted", description: "Delete Successfully", duration: 3 });
                PageLoading();
                getOnboarderedUsers();
            })
            .catch((err) => {
                if (err.apiError?.status) notification.error({ message: "Error", description: err.apiError.message });
            });
    };
    const showDeleteConfirm = (user) => {
        confirm({
            title: `Are you sure you want to delete user "${user?.email}"?`,
            content: "This action cannot be undone.",
            okText: "Yes, Delete",
            okType: "danger",
            cancelText: "Cancel",
            onOk() {
                handleDeleteUser(user?.id);
            },
        });
    };
    const showResendEmailVerficationLinkConfirm = (user) => {
        confirm({
            title: `Resend email verification link for user "${user?.email}"?`,
            content: "The user might not have received it or it expired.",
            okText: "Yes, Send",
            okType: "primary",
            cancelText: "Cancel",
            onOk() {
                UserApi.resendVerifyToken(user?.email)
                    .then(() => {
                        notification.success({ message: "Email verification link resent successfully!", duration: 3 });
                        PageLoading();
                        getOnboarderedUsers();
                    })
                    .catch((err) => {
                        if (err.apiError?.status) notification.error({ message: "Error", description: err.apiError.message });
                    });
            },
        });
    };

    // -------------------------
    // Table rendering
    // -------------------------
    const renderTableRows = () => {
        return TenantsUsers.map((item) => (
            <tr key={item?.id} className="text-center">
                <td className="user-tableAvatar">
                    <div
                        style={{
                            width: "30px",
                            height: "30px",
                            borderRadius: "50%",
                            background: "#001529",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            marginLeft: "8px",
                            fontWeight: "bold",
                            padding: "5px",
                            color: "#fff",
                            cursor: "pointer",
                            marginRight: "10px",
                            animation: "flash 1s infinite",
                        }}
                    >
                        {item?.firstName?.charAt(0)}
                        {item?.lastName?.charAt(0)}
                    </div>
                    <div>{item?.firstName} {item?.lastName}</div>
                </td>
                <td style={{ width: "22%" }}>{item?.email}</td>
                <td style={{ width: "22%" }} className="text-center">
                    {item?.aptitudeTestStatus === "COMPLETED" && <Tag color="green">{item?.aptitudeTestStatus}</Tag>}
                    {item?.aptitudeTestStatus === "PENDING" && <Tag color="orange">{item?.aptitudeTestStatus}</Tag>}
                </td>
                <td>{item?.roleDTOs[0].name}</td>
                <td style={{ width: "22%" }}>{new Date(item?.createdDate).toLocaleDateString()} | {new Date(item?.createdDate).toLocaleTimeString()}</td>
                <td>
                    <Button
                        style={{ height: "30px" }}
                        type="primary"
                        onClick={() => {
                            setSelectedUser(item);
                            setIsAssignModalVisible(true);
                        }}
                    >
                        Assign login code
                    </Button>
                </td>
            </tr>
        ));
    };


    return (
        <Layout style={{ minHeight: "100vh" }}>
            <Sidebar />
            <Layout>
                <TopHeader />
                {isLoading && <div className="spinner-overlay"><div className="spinner"></div></div>}

                {/* Filter Section */}
                <div style={{ padding: "20px", paddingBottom: "5px" }}>
                    <Form name="filterForm" layout="vertical" className="FilterForm" onFinish={handleSubmit}>
                        <Collapse>
                            <Panel header={<h5 className="mb-0"><b>Filter</b></h5>} key="1">
                                {filterUser.map((input, index) => (
                                    <Row key={index} gutter={12}>
                                        <Col span={5}>
                                            <Form.Item rules={[{ required: true, message: "Please Select" }]}>
                                                <Select placeholder="Filter By" value={input.title} onChange={(value) => handleChangeTitle(index, value)} options={[{ value: "firstName", label: "Name" }, { value: "email", label: "Email" }]} />
                                            </Form.Item>
                                        </Col>
                                        <Col span={4}>
                                            <Form.Item rules={[{ required: true, message: "Please Select type." }]}>
                                                <Select placeholder="Condition" value={input.answerType} onChange={(value) => handleChangeAnswertype(index, value)} options={[{ value: "%", label: "Matches with" }, { value: "=", label: "Equals to" }]} />
                                            </Form.Item>
                                        </Col>
                                        <Col span={5}>
                                            <Form.Item rules={[{ required: true, message: "Please enter Text." }]}>
                                                <Input value={input.name} onChange={(e) => handleChangename(index, e.target.value)} placeholder="Text" />
                                            </Form.Item>
                                        </Col>
                                        <Col span={8}>
                                            {index === 0 ? (
                                                <Row gutter={23} className="mb-3">
                                                    <Col span={2}><PlusCircleTwoTone onClick={handleAddfilterUser} /></Col>
                                                    <Col span={10}><Button type="primary" htmlType="submit">Filter</Button></Col>
                                                    <Col span={10}><Button type="default" htmlType="reset" onClick={handleClear}>Clear</Button></Col>
                                                </Row>
                                            ) : <MinusCircleTwoTone onClick={() => handleRemovefilterUser(index)} />}
                                        </Col>
                                    </Row>
                                ))}
                            </Panel>
                        </Collapse>
                    </Form>
                </div>

                {/* Users Table */}
                <Content className="form-content nav-content" style={{ margin: "14px 16px 0", padding: "30px", background: "white" }}>
                    <div className="d-flex justify-content-between align-items-center mb-2">
                        <div></div>
                        <Form form={formPaginate}><Form.Item name="paginate" style={{ width: "100px" }}><Select onChange={handlesetPaginateLimit} options={[{ value: 10, label: "10" }, { value: 20, label: "20" }, { value: 30, label: "30" }, { value: 40, label: "40" }, { value: 50, label: "50" }]} /></Form.Item></Form>
                    </div>
                    <table className="table Tenants-table">
                        <thead>
                            <tr>
                                <th>Full Name</th>
                                <th className="text-center">Email</th>
                                <th className="text-center">Status</th>
                                <th className="text-center">Role</th>
                                <th>Registered Date</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>{renderTableRows()}</tbody>
                    </table>
                    {TenantsUsers.length > 0 && (
                    <Pagination
                        currentPage={currentPage}
                        totalPages={PaginatetotalPages}
                        onPageChange={handlePageChange}
                        maxVisiblePages={5}
                        showPageInfo={true}
                        totalItems={totalElements}
                        pageSize={PaginateLimit}
                    />
                    )}
                </Content>
                {/* <FooterDashboard /> */}

                {/* Assign Login Code Modal */}
                <Modal
                    title={`Assign Login Code to ${selectedUser?.firstName || ""} ${selectedUser?.lastName || ""}`}
                    open={isAssignModalVisible}
                    onCancel={() => { setIsAssignModalVisible(false); setLoginCode(""); setLoginCodeError(""); }}
                    onOk={handleAssignLoginCode}
                    okText="Assign"
                    cancelText="Cancel"
                    okButtonProps={{ disabled: !!loginCodeError || !loginCode }}
                >
                    <Input
                        placeholder="Enter login code"
                        value={loginCode}
                        onChange={handleLoginCodeChange}
                    />
                    {loginCodeError && <Text type="danger">{loginCodeError}</Text>}
                </Modal>
            </Layout>
        </Layout>
    );
};

export default OnboardedUsers;
